import { StarRdEnvironment } from 'global-types';

export const environment: StarRdEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://star-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://rewards-auth.staralliance.com',
  clientId: '2becbcbb-f33a-4b1c-8bff-27b64e1dd1c9',
  connection: 'password',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://rewards.staralliance.com/',
  // TODO: change this to the correct url when we release TE in the future
  // https://kaligo.slack.com/archives/C02UTAPHPEV/p1659340918692409?thread_ts=1658392693.952169&cid=C02UTAPHPEV
  travelEdgeBaseUrl: 'https://www.kaligo.com',
  tenantTncsUrl: 'https://www.staralliance.com/en/web/rewards/au/tnc',
  tenantPrivacyPolicyUrl:
    'https://www.staralliance.com/en/web/rewards/au/privacy-policy',
  tenantPrivacyStatementUrl:
    'https://www.staralliance.com/en/web/rewards/au/privacy-statement',
  brandName: 'StarAlliance',
  shortBrandName: 'STAR',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 1200,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 60,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'staralliance.com',
  },
  prismicConfig: {
    apiUrl: 'https://ascendaloyalty.prismic.io/api/v2',
    accessToken:
      'MC5ZSFpteHhNQUFDSUFxMERB.fu-_vX3vv73vv73vv70UFu-_vXJQ77-977-977-977-9I--_vU84R--_vR_vv70z77-977-9Ue-_vUNU77-977-9',
  },
  appId: '5c332153-47e6-404f-9bdf-760478b7c1f4',
  unleashAppName: 'rd-star-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
